import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import Location from "../location/Location";

const ContactUs = () => {
  return (
    <div>
      <Header />
      <Location />
      <Footer />
    </div>
  );
};

export default ContactUs;
